// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"a869f636","285":"72dcd743","453":"6cefbc99"}[chunkId] + ".chunk.js";
};